import { NoteResponse, NoteResponseItem } from '@/types/service-response'

export class Note {
  public constructor (
    readonly id: number | undefined,
    readonly addressEmployee: string,
    readonly addressEmployeeId: number | undefined,
    readonly responsibleEmployee: number | undefined,
    readonly dateStartIso: string,
    readonly dateEndIso: string,
    readonly alreadyDone: number,
    readonly author: number | undefined,
    readonly isPrivate: boolean,
    readonly noteType: number | undefined,
    readonly noteTitle: string,
    readonly noteText: string,
    readonly addressResponsibleEmployee: number | undefined,
    readonly quality: number | null
  ) {}

  static createFromResponse (responseData: NoteResponse): Array<Note> {
    let result: Array<Note> = []
    if (responseData) {
      result = responseData.map((item: NoteResponseItem ) => {
        return new Note(
          item.ID,
          item.Sachbearbeiter ? item.Sachbearbeiter : '',
          item.SachbearbeiterID ? item.SachbearbeiterID : undefined,
          item.Verantwortlich ? item.Verantwortlich : undefined,
          item.Beginn ? item.Beginn : '',
          item.Faellig ? item.Faellig : '',
          item.Erledigt ? item.Erledigt : 0,
          item.Author ? item.Author : undefined,
          item.Privat,
          item.NotizArt ? item.NotizArt : undefined,
          item.Titel ? item.Titel : '',
          item.Beschreibung ? item.Beschreibung : '',
          item.AdressVerantwortlich ? item.AdressVerantwortlich : undefined,
          item.Qualitaet
        )
      })
    }
    return result
  }
}
